module.exports = __webpack_public_path__ + "img/question_answer.27cd1700.svg";